export function Marquee({ copy }) {
  const items = [...copy.marquee, ...copy.marquee];
  return (
    <section className="marquee" aria-label="Services" data-testid="editorial-services-marquee">
      <div className="marquee-viewport"><div className="marquee-track">{items.map((item, index) => <span className="marquee-item" key={`${item}-${index}`}>{item}<b>✳</b></span>)}</div></div>
    </section>
  );
}
